import { Component, Input, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { UserTimePipe } from "app/components/shared/UserTimePipe";
import { LoadingService } from "app/services/loading-service/loading.service";
import { ConfirmationService, SelectItem } from "primeng/api";
import { EntityListComponent } from 'app/components/entity-list/entity-list.component';
import { Rest } from 'app/rest/rest_client';
import { NotificationsService } from 'app/services/notifications-service/notifications.service';
import { AuthenticationService } from 'app/core/services/authentication/authentication.service';
import { I18nService } from 'app/services/i18n/i18n.service';
import { TranslateService } from '@ngx-translate/core';
import { ExcelService } from "app/services/excel-service/excel.service";
import { BreakdownFollowingService } from '../../../../../services/table-management/breakdownFollowing.service';
import { BreakdownFollowingFormComponent } from '../breakdown-following-form/breakdown-following-form.component';

@Component({
  selector: 'app-breakdown-following-list',
  templateUrl: './breakdown-following-list.component.html',
  styleUrls: ['./breakdown-following-list.component.css'],
  providers:[BreakdownFollowingService, ConfirmationService, UserTimePipe, ExcelService],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class BreakdownFollowingListComponent extends EntityListComponent<Rest.InvBreakdownFollowing>
  implements OnInit {

  @ViewChild(BreakdownFollowingFormComponent, { static: true })
    breakdownFollowingForm: BreakdownFollowingFormComponent;
  
    title: string = this.translateService.instant('tableManagement.breakdown.breakdownFollowing.title');
    disableSave: boolean;
    EnabledFilter: SelectItem[];
    isCreateGranted: boolean;
    isDisabledGranted: boolean;

    @Input() breakdown: Rest.InvBreakdown;
  
    constructor(
      private breakdownFollowingService: BreakdownFollowingService,
      protected confirmationService: ConfirmationService,
      public notificationsService: NotificationsService,
      protected i18n: I18nService,
      authenticationService: AuthenticationService,
      protected loadingService: LoadingService,
      protected userTime: UserTimePipe,
      protected excelService: ExcelService,
      protected translateService: TranslateService,
    ) {
      super(
        breakdownFollowingService,
        confirmationService,
        notificationsService,
        i18n,
        authenticationService,
        loadingService,
        userTime,
        excelService
      );
      this.breakdownFollowingService = breakdownFollowingService;
    }
  
    ngOnInit() {
      super.ngOnInit();
      this.form = this.breakdownFollowingForm;
      this.setPermissions();
    }

    setPermissions() {
        const user = this.authenticationService.user;
        this.isCreateGranted = this.authenticationService.isRoleGranted('INV_FOLLOWING_BREAKDOWN_CREATE', user);
        this.isDisabledGranted = this.authenticationService.isRoleGranted('INV_FOLLOWING_BREAKDOWN_DISABLE', user);

    }

    beforeLoad() {
      
      this.paginationRequest.sortAsc= false;
      if (this.paginationRequest.filters.hasOwnProperty("disabled")) {
        this.paginationRequest.filters["disabled"] = this.paginationRequest.filters["disabled"][0].toString() == "true" ? ["false"] : ["true"];
      }

      if(this.breakdown){
        this.paginationRequest.filters["breakdownId"] = [this.breakdown.id.toString()];
      }

    }
  
    afterLoad() {
      
    }
    excelColumns = {};
    exportExcel() {
      this.setExcelColumns();
      let fileNameTitle = this.translateService.instant('tableManagement.breakdown.breakdownFollowing.title');
      super.exportExcelWithColumns(fileNameTitle, this.excelColumns);
    }
    setExcelColumns() {
      const vehicleQualityCommitmentDate = (entity: any) => entity.vehicleQualityCommitmentDate ?? ''
      const vehicleRentingDate = (entity: any) => entity.vehicleRentingDate ?? ''
      const vehicleReplacement = (entity: any) => entity.vehicleReplacement ?? ''
      const replacementVehicleCollectionDate = (entity: any) => entity.replacementVehicleCollectionDate ?? ''
      const replacementVehicleReturnDate = (entity: any) => entity.replacementVehicleReturnDate ?? ''
      const disabled = (entity: any) => !entity.disabled
      this.excelColumns = {
        [this.translateService.instant('tableManagement.breakdown.breakdownFollowing.vehicleQualityCommitmentDate')]: { bindField: vehicleQualityCommitmentDate },
        [this.translateService.instant('tableManagement.breakdown.breakdownFollowing.vehicleRentingDate')]: { bindField: vehicleRentingDate },
        [this.translateService.instant('tableManagement.breakdown.breakdownFollowing.vehicleReplacement')]: { bindField: vehicleReplacement },
        [this.translateService.instant('tableManagement.breakdown.breakdownFollowing.replacementVehicleCollectionDate')]: { bindField: replacementVehicleCollectionDate },
        [this.translateService.instant('tableManagement.breakdown.breakdownFollowing.replacementVehicleReturnDate')]: { bindField: replacementVehicleReturnDate },
        [this.translateService.instant('general.active')]: { bindField: disabled },
      }
    }

}